import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Checkbox, Row, Col } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import Button from 'shared/button';

import Modal from 'components/modal';
import { includes } from 'lodash';

export default function AllFiltersModal({
  closeModal,
  dataForFilters,
  dynamicFilters,
  show,
  staringFilters,
  onChangeFilters,
  onClearFilters
}) {
  const [filters, setFilters] = useState(staringFilters);

  useEffect(() => {
    resetFilters();
  }, [show]);

  const onStartDateUpdate = (date) => {
    setFilters({ ...filters, startDate: date });
  };

  const onEndDateUpdate = (date) => {
    setFilters({ ...filters, endDate: date });
  };

  const checkboxDisplay = (filter, option) => {
    return (
      <Checkbox
        aria-label={option.label}
        checked={includes(filters[filter], option.value)}
        key={option.value}
        name={`${option.label}_check`}
        onChange={e => changeFilters(e, filter, option.value)}
      >
        {option.label}
      </Checkbox>
    );
  };

  const filterBoxStyles = {
    border: '1px solid #ccc',
    padding: '0 10px',
    borderRadius: '5px',
    maxHeight: '100px',
    overflowY: 'auto',
    flexGrow: '1',
  };

  const renderFilterBox = (filterKey, dataKey, label, topFilter = true, spanFullLength = false) => {
    const options = dataForFilters[dataKey];

    return (
      <Col className="d-flex flex-column" sm={spanFullLength ? 12 : 6}>
        <h5 className={`mb-2 ${topFilter ? 'mt-4' : 'mt-0'}`}>{label}</h5>
        <div style={filterBoxStyles}>
          {options && options.map(option => (
            checkboxDisplay(filterKey, option)
          ))}
        </div>
      </Col>
    );
  };

  const saveFilters = () => {
    onChangeFilters(filters);
    closeModal();
  };

  const changeFilters = (e, filter, optionId) => {
    const { checked } = e.target;
    if (checked) {
      setFilters({ ...filters, [filter]: [...filters[filter], optionId] });
    } else {
      setFilters({ ...filters, [filter]: filters[filter].filter(id => id !== optionId) });
    }
  };

  const resetFilters = () => setFilters(staringFilters);

  const cancelFilters = () => {
    resetFilters();
    closeModal();
  };

  const clearFilters = () => {
    onClearFilters();
    closeModal();
  };

  const validDynamicFilters = dynamicFilters.filter((dynamicFilter) => {
    const options = dataForFilters[dynamicFilter.dataKey];
    return options.length > 1;
  });

  return (
    <Modal show={show} onHide={closeModal}>
      <Modal.Header closeButton>
        All Filters
      </Modal.Header>

      <Modal.Body>
        <Row className="d-flex flex-wrap">
          {validDynamicFilters.map((dynamicFilter, index) => {
            const hasTopFilter = index > 1;
            const isLastFilterAndIsOdd = index === validDynamicFilters.length - 1 && (index + 1) % 2 === 1;
            return (
              <React.Fragment key={dynamicFilter.dataKey}>
                {renderFilterBox(dynamicFilter.filterKey, dynamicFilter.dataKey, dynamicFilter.label,
                  hasTopFilter, isLastFilterAndIsOdd)}
              </React.Fragment>
            );
          })}
        </Row>

        <h5 className="mb-2 mt-4">Date Added</h5>
        <Row>
          <Col sm={6}>
            <DatePicker
              className="form-control"
              maxDate={filters.endDate}
              placeholderText="Start Date"
              selected={filters['startDate']}
              wrapperClassName="w-100"
              onChange={date => onStartDateUpdate(date)}
            />
          </Col>
          <Col sm={6}>
            <DatePicker
              className="form-control"
              minDate={filters.startDate}
              placeholderText="End Date"
              selected={filters['endDate']}
              wrapperClassName="w-100"
              onChange={date => onEndDateUpdate(date)}
            />
          </Col>
        </Row>
        <Row className="mt-4">
          <Col sm={8}>
            <Button.Danger className="ds-button--plain p-0" name="clearFilters" onClick={clearFilters}>
              X Clear All
            </Button.Danger>
          </Col>
          <Col className="text-right" sm={4}>
            <Button.Cancel className="mr-2" name="cancel" onClick={cancelFilters}>
              Cancel
            </Button.Cancel>
            <Button.Primary name="saveFilters" onClick={saveFilters}>
              Apply Filters
            </Button.Primary>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  );
}

AllFiltersModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  dataForFilters: PropTypes.object.isRequired,
  dynamicFilters: PropTypes.arrayOf(PropTypes.shape({
    dataKey: PropTypes.string.isRequired,
    filterKey: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
  })).isRequired,
  show: PropTypes.bool.isRequired,
  staringFilters: PropTypes.object.isRequired,
  onChangeFilters: PropTypes.func.isRequired,
  onClearFilters: PropTypes.func.isRequired
};
